var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-afil" },
    [
      _c(
        "span",
        {
          staticClass: "blue-red-hover-text",
          on: {
            click: function ($event) {
              return _vm.FIOclickHandle()
            },
          },
        },
        [
          _vm._t("default", function () {
            return [_vm._v(_vm._s(_vm.fio))]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showAfilNetworkTooltip
        ? _c("afilNetWorkTooltip", { attrs: { inn: _vm.inn, fio: _vm.fio } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            {
              attrs: {
                printButton: true,
                downloadButton: true,
                close: function () {
                  this$1.showModal = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "modalHeader" }, slot: "modalHeader" },
                [_vm._v("Аффилированность")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { padding: "15px 15px 5px" },
                  attrs: { slot: "modalBody" },
                  slot: "modalBody",
                },
                [
                  _c("div", [
                    _c("b", [_vm._v("ФИО:")]),
                    _vm._v(" " + _vm._s(_vm.onlyFirstLetterBig(_vm.fio))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("ИНН:")]),
                    _vm._v(" " + _vm._s(_vm.inn)),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.loading
                      ? _c("div", [_c("shestirenka")], 1)
                      : _vm.afilData
                      ? _c("div", [
                          _vm.afilData.upr.length && _vm.afilData.uchr.length
                            ? _c(
                                "div",
                                [
                                  _vm.afilData.uchr.filter(function (e) {
                                    return !e.stakeholder_date_end
                                  }).length >= 5
                                    ? _c("massFactor", [
                                        _vm._v(
                                          "\n                            Является учредителем в " +
                                            _vm._s(
                                              _vm.afilData.uchr.filter(
                                                function (e) {
                                                  return !e.stakeholder_date_end
                                                }
                                              ).length
                                            ) +
                                            " ЮЛ и имеет признаки «массового учредителя».\n                        "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.afilData.upr.filter(function (e) {
                                    return !e.stakeholder_date_end
                                  }).length >= 10
                                    ? _c("massFactor", [
                                        _vm._v(
                                          "\n                            Является руководителем в " +
                                            _vm._s(
                                              _vm.afilData.upr.filter(function (
                                                e
                                              ) {
                                                return !e.stakeholder_date_end
                                              }).length
                                            ) +
                                            " ЮЛ и имеет признаки «массового руководителя».\n                        "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.afilData.upr && _vm.afilData.upr.length
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v(_vm._s(_vm.typeName("upr"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: { afilArray: _vm.afilData.upr },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.afilData.upr,
                                      type: "upr",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.afilData.uchr && _vm.afilData.uchr.length
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v(_vm._s(_vm.typeName("uchr"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: { afilArray: _vm.afilData.uchr },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.afilData.uchr,
                                      type: "uchr",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.afilData.mbupr && _vm.afilData.mbupr.length
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v(_vm._s(_vm.typeName("mbupr"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: { afilArray: _vm.afilData.mbupr },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.afilData.mbupr,
                                      type: "mbupr",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.afilData.mbuchr && _vm.afilData.mbuchr.length
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v(_vm._s(_vm.typeName("mbuchr"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: { afilArray: _vm.afilData.mbuchr },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.afilData.mbuchr,
                                      type: "mbuchr",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.afilData.upr_history &&
                          _vm.afilData.upr_history.length
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v(_vm._s(_vm.typeName("upr_history"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: {
                                      afilArray: _vm.afilData.upr_history,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.afilData.upr_history,
                                      type: "upr_history",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.afilData.uchr_history &&
                          _vm.afilData.uchr_history.length
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v(
                                      _vm._s(_vm.typeName("uchr_history"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: {
                                      afilArray: _vm.afilData.uchr_history,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.afilData.uchr_history,
                                      type: "uchr_history",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.history
                            ? _c(
                                "div",
                                [
                                  _c("p", { staticClass: "type-header" }, [
                                    _vm._v("Исторические связи"),
                                  ]),
                                  _vm._v(" "),
                                  _c("personAfilTable", {
                                    attrs: { afilArray: _vm.history.ul },
                                  }),
                                  _vm._v(" "),
                                  _c("personAfilStats", {
                                    attrs: {
                                      afilArray: _vm.history.ul,
                                      type: "history",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }